import { render, staticRenderFns } from "./ToS.vue?vue&type=template&id=2a8bca3d&scoped=true&"
import script from "./ToS.vue?vue&type=script&lang=js&"
export * from "./ToS.vue?vue&type=script&lang=js&"
import style0 from "./ToS.vue?vue&type=style&index=0&id=2a8bca3d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8bca3d",
  null
  
)

export default component.exports